export default {
  getChannelData: state => state.channelData,
  getChannelsList: state => state.channelsList,
  getFollowingList: state => state.followingList,
  getFollowingCount: state => state.followingCount,
};
